export enum HealthCheckState {
  Pending,
  Completed,
  CompletedWithSymptoms,
}
